// extracted by mini-css-extract-plugin
export var container = "_78-0";
export var infoButton = "_78-1";
export var label = "_78-3";
export var labelExpanded = "_78-4";
export var price = "_78-5";
export var priceExpanded = "_78-6";
export var title = "_78-2";